export const LEGAL_CONFIG = {
  // URLs
  PRIVACY_POLICY_URL: "/privacy",
  TERMS_OF_SERVICE_URL: "/terms",
  APPLE_EULA_URL: "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/",
  
  // Metadata
  LAST_UPDATED: "December 6, 2025",
  
  // Business Info
  BUSINESS_NAME: "Wellness Cowgirls",
  SUPPORT_EMAIL: "customersupport@moorewellnessgroup.com",
  BUSINESS_ADDRESS: "San Antonio, Texas",
  
  // App Store URLs (for reference)
  APP_STORE_PRIVACY_URL: "/privacy", // Use this in App Store Connect
};
